import Service from "../../AuthService";

const repair = {
    getRepair(page) {
        return Service.get("/repair-cost?page=" + page);
    },
    showRepair(id) {
        return Service.get("/repair-cost/" + id);
    },
    updateRepair(id, data) {
        return Service.put("/repair-cost/" + id, data);
    },
    createRepair(data) {
        return Service.post("/repair-cost", data);
    },
    deleteRepair(id) {
        return Service.delete("/repair-cost/" + id);
    },
    search(page, data) {
        //console.log(data);
        return Service.post('repair-cost-search?page=' + page, data);
    }

};
export default repair;
